/* eslint-disable @typescript-eslint/no-unsafe-call */
import type { AllBrandData } from "src/types/adapters/browse.type";

const allBrandsSorted = (brands: AllBrandData[]) => {
  const sorted = brands?.sort((a, b) => a.name.localeCompare(b.name));

  return sorted;
};

const alphabetLetters: Record<string, AllBrandData[]> = {
  "#": [],
  a: [],
  b: [],
  c: [],
  d: [],
  e: [],
  f: [],
  g: [],
  h: [],
  i: [],
  j: [],
  k: [],
  l: [],
  m: [],
  n: [],
  o: [],
  p: [],
  q: [],
  r: [],
  s: [],
  t: [],
  u: [],
  v: [],
  w: [],
  x: [],
  y: [],
  z: [],
};

function composeBrandsByFirstLetter(brands: AllBrandData[]) {
  const sortedBrands = allBrandsSorted(brands);

  const result = sortedBrands?.reduce(
    (alphabet, currentBrand) => {
      const [firstChar] = currentBrand.name.toLowerCase();

      if (!alphabetLetters[firstChar]) {
        alphabet["#"] = [...(alphabet["#"] || []), currentBrand];
      } else {
        alphabet[firstChar] = [...(alphabet[firstChar] || []), currentBrand];
      }

      return alphabet;
    },
    { "#": [] } as Record<string, AllBrandData[]>
  );

  return { ...alphabetLetters, ...result };
}

export { allBrandsSorted, composeBrandsByFirstLetter };
